<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import Datepicker from 'vuejs-datepicker';
import SlotDetails from './SlotDetails'
import WeekendDetails from './WeekendDetails'
import moduleHoliday from "@/store/holiday/moduleHoliday.js";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    SlotDetails,
    Datepicker,
    WeekendDetails
  },
  data() {
    return {
      selectedYear:new Date().getFullYear(),
      calendarPlugins: [ dayGridPlugin,listPlugin, timeGridPlugin, interactionPlugin ],
     confirmPeriod:{},
     format:"dd-MM-yyyy",
      addNewDataSidebar: false,
      weekendSidebar:false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,

    }
  },
   methods:{
     openConfirmImport() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:  this.$t("Confirm"),
        text:this.$t("Areyousureyouwantimportholidayforyear") +this.selectedYear+ this.$t("fromgoogle") + " ?",
        accept: this.ImportGoogleHoliday
      });
    },



     ImportGoogleHoliday()
     {
       this.$store.dispatch("holidayList/ImportGoogleHoliday",this.selectedYear);
     },

     addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    CloseSidebar(event) {
      console.log(event);
      if(event!=undefined)
      {

            this.$refs.holidayCalendar.$emit("addEvent",event);
            this.$refs.holidayCalendar.$emit('refetch-events')
      }
      this.addNewDataSidebar = false;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },

      toggleWeekendSidebar(val = false) {
      this.weekendSidebar = val;
    },
    handleDateClick(arg) {
      this.sidebarData.StartDate = arg.date;
      debugger
      this.toggleDataSidebar(true);
    },

    handleDateSelect(arg) {
      this.sidebarData={};
      this.sidebarData.start = arg.start;
      this.sidebarData.end = arg.end;
          debugger
      this.toggleDataSidebar(true);
    },

    eventClick(arg)
    {
       debugger
       this.sidebarData.start = arg.event.start;
       this.sidebarData.end = arg.event.end;
       this.sidebarData.ID = arg.event.extendedProps.ID;
       this.sidebarData.Description = arg.event.extendedProps.Description;
       this.sidebarData.title = arg.event.title;
       this.toggleDataSidebar(true);
    },

    formatJsDate(dateToFormat)
    {
         return dateToFormat.getFullYear()+"-"+ (dateToFormat.getMonth()+1)+"-"+dateToFormat.getDate();
    },

    handleMonthChange: function(arg)
    {
        debugger
        var period={};
        period.start=this.formatJsDate(arg.view.activeStart);
        period.end=this.formatJsDate(arg.view.activeEnd);
         this.selectedYear=arg.view.currentStart.getFullYear();
        this.$store.dispatch("holidayList/GetHolidayInPeriod",period).then(()=>{
           this.$refs.holidayCalendar.getApi().updateSize()
        }).catch(err => {
          console.error(err);
        });
     },

      eventDrop(arg)
      {
          var obj= JSON.parse(JSON.stringify( arg.event.extendedProps)) ;
        obj.start= arg.event.start;
        obj.end=arg.event.end;
         obj.title=arg.event.title
            this.$store.dispatch("holidayList/updateItem",  obj).catch(err => {
              console.error(err);
            });
      },

      eventResize(arg)
      {
          var obj= JSON.parse(JSON.stringify( arg.event.extendedProps)) ;
         obj.title=arg.event.title
          obj.start= arg.event.start;
          obj.end=arg.event.end;
            this.$store.dispatch("holidayList/updateItem",  obj).catch(err => {
              console.error(err);
            });
      },

       confirmEventInPeriod()
       {
          this.$store.dispatch("holidayList/confirmEventInPeriod",this.confirmPeriod).then(()=>{
            this.confirmPeriod={};
            this.$refs.holidayCalendar.getApi().next();
            this.$refs.holidayCalendar.getApi().prev();
          }).catch(err => {
            console.error(err);
          });
       }
    },

   created() {
    if (!moduleHoliday.isRegistered) {
      this.$store.registerModule("holidayList", moduleHoliday);
      moduleHoliday.isRegistered = true;
    }
     this.$store.dispatch("holidayList/GetWeekdays");
  },

  computed:{
    isConfirmFormValid(){
      return this.confirmPeriod.dateFrom&&this.confirmPeriod.dateTo;
    },
      events() {
      return this.$store.state.holidayList.holidays;
    }
  }
}

</script>

<template>
  <div >
    <slot-details :isSidebarActive="addNewDataSidebar" @closeSidebar="CloseSidebar" :data="sidebarData" />
      <WeekendDetails :isSidebarActive="weekendSidebar" @closeSidebar="toggleWeekendSidebar" :data="toggleWeekendSidebar" />
       <vs-button  type="border"  v-if="selectedYear>=new Date().getFullYear()-1&&selectedYear<=new Date().getFullYear()+1" class="mb-6 mr-6"
       @click="openConfirmImport()" >{{$t('ImportFromGoogle')}}</vs-button>
        <vs-button  type="border" class="mb-6" @click="toggleWeekendSidebar(true)" > {{$t('Weekends')}}</vs-button>
     <div class="vx-card">
        <FullCalendar defaultView="dayGridMonth"  @datesRender="handleMonthChange"  @eventClick="eventClick" ref="holidayCalendar" selectable="true" :plugins="calendarPlugins" @dateClick="handleDateClick" @select="handleDateSelect"
            :events="this.$store.state.holidayList.holidays"
            editable="true" @eventDrop="eventDrop" @eventResize="eventResize"
            :header="{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek'
              }"
          />
     </div>
  </div>
</template>

<style lang='scss'>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
</style>
